export type Contract = {
	readonly type: ContractType,
	readonly isProvisional: boolean,
	readonly expirationDate: string,
	readonly vipBasicExpirationDate: string
};

export enum ContractType {
	VIP_BASIC = 'VIP_BASIC',
	VIP_UPGRADE = 'VIP_UPGRADE',
	VIP_PLUS = 'VIP_PLUS',
	BASIC = 'BASIC',
	PLUS = 'PLUS',
	EMPLOYEE = 'EMPLOYEE'
}

export enum ContractTypeDisplayName {
	VIP_BASIC = 'VIP Basic',
	VIP_UPGRADE = 'VIP Upgrade',
	VIP_PLUS = 'VIP Plus',
	BASIC = 'Basic',
	PLUS = 'Plus',
	EMPLOYEE = 'Mitarbeiter*in'
}

